/**
 * Carnatic thaalam reference.
 *
 * Covers the 7 Suladi Sapta Talas (in their default Chaturasra jaathi, laghu = 4)
 * plus the two common Chapu talas. Each thaalam's `angas` (sub-groups) sum to `beats`
 * (aksharas). This drives the metronome/thaalam engine (FR-8).
 *
 * Anga durations: Anudrutam (U) = 1, Drutam (O) = 2, Laghu (L) = jaathi (here 4).
 */
const L = 4; // Chaturasra laghu
const O = 2; // Drutam
const U = 1; // Anudrutam
function thaalam(name, angas) {
    return { name, angas, beats: angas.reduce((a, b) => a + b, 0) };
}
/** The 7 Suladi Sapta Talas (Chaturasra jaathi) + Chapu talas. */
export const THAALAMS = [
    // Chaturasra-jaathi Triputa is the ubiquitous "Adi" thaalam (8 beats).
    thaalam('Adi', [L, O, O]),
    thaalam('Dhruva', [L, O, L, L]),
    thaalam('Matya', [L, O, L]),
    thaalam('Rupaka', [O, L]),
    thaalam('Jhampa', [L, U, O]),
    thaalam('Triputa', [L, O, O]),
    thaalam('Ata', [L, L, O, O]),
    thaalam('Eka', [L]),
    // Chapu talas (not laghu-based; felt as uneven groups).
    thaalam('Misra Chapu', [3, 4]), // 7 aksharas
    thaalam('Khanda Chapu', [2, 3]), // 5 aksharas
];
const THAALAM_BY_NAME = new Map(THAALAMS.map((t) => [t.name.toLowerCase(), t]));
/** Case-insensitive thaalam lookup by name. */
export function getThaalam(name) {
    return THAALAM_BY_NAME.get(name.trim().toLowerCase());
}
//# sourceMappingURL=thaalams.js.map